module.exports = __webpack_public_path__ + "img/1_smoke.6de97af4.png";